import Box from "@mui/material/Box";
import HiltonLogo from "assets/HiltonBoostLogo.svg";
import { useNavigate } from "react-router-dom";
import { useAppSelector } from "redux/hooks";

function Logo() {
  const navigate = useNavigate();
  const isImpersonated = useAppSelector((state: any) => state.app.impersonationDetails.isImpersonated);

  const homePage = () => {
    if (isImpersonated) {
      navigate("/");
    } else {
      window.location.replace("/");
    }
  };

  return (
    <Box
      component="img"
      sx={{
        height: "30px",
        justifySelf: "center",
        cursor: "pointer"
      }}
      alt="Hilton Logo"
      src={HiltonLogo}
      onClick={homePage}
    />
  );
}

export default Logo;
